module.exports = __webpack_public_path__ + "img/conversions.4885612c.svg";